module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "iapp"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "iapp-bg"
  }, [_c('div', {
    staticClass: "iapp-page max_width"
  }, [_c('div', {
    staticClass: "iapp_title"
  }, [_c('div', {
    staticClass: "iapp_title_img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/iapp_icon.png"),
      "width": "50%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "iapp_home"
  }, [_c('i-col', {
    staticClass: "iapp_home_right",
    attrs: {
      "lg": 10,
      "md": 10,
      "sm": 24,
      "xl": 24
    }
  }, [(_vm.type === 'a') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_home.png")
    }
  }) : (_vm.type === 'b') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_home_fancn.png")
    }
  }) : (_vm.type === 'c') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_home_fancn.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('i-col', {
    staticClass: "iapp_home_left",
    attrs: {
      "lg": 14,
      "md": 14,
      "sm": 24,
      "xl": 24
    }
  }, [_c('div', {
    staticClass: "iapp_home_content"
  }, [_vm._v(_vm._s(_vm.$t('iapp_title')))]), _vm._v(" "), _c('div', {
    staticClass: "iapp_home_content_tips"
  }, [_vm._v(_vm._s(_vm.$t('iapp_sm_title')))]), _vm._v(" "), _c('div', {
    staticClass: "iapp_download_container "
  }, [_c('div', {
    staticClass: "iapp_download_item"
  }, [_c('img', {
    staticClass: "iapp_qrcode",
    attrs: {
      "src": require("../../assets/xiaochengxu.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('mini_program')))])]), _vm._v(" "), _c('div', {
    staticClass: "iapp_download_item"
  }, [_c('img', {
    staticClass: "iapp_qrcode",
    attrs: {
      "src": require("../../assets/iapp.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('user_center_iapp_qrcode')))])]), _vm._v(" "), _c('div', {
    staticClass: "iapp_download_item",
    attrs: {
      "id": "mobile_hide"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/iapp-best-travel-companion/id1210741206?mt=8"
    }
  }, [_c('img', {
    staticClass: "ios_download",
    attrs: {
      "src": require("../../assets/iapp/iOS@2x.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/android"
    }
  }, [_c('img', {
    staticClass: "android_download",
    attrs: {
      "src": require("../../assets/iapp/Android@2x.png")
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "home_title_img"
  }, [_vm._v("iAPP")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "iapp_content"
  }, [_c('div', {
    staticClass: "iapp_tab_main max_width"
  }, [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "iapp_tab "
  }, [_vm._v(_vm._s(_vm.$t('iapp_content')))]), _vm._v(" "), _c('div', {
    staticClass: "iapp_tab_group"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "iapp_tab_item",
      class: {
        active: index == _vm.num
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.tab(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "iapp_tab_content"
  }, _vm._l((_vm.tabContents), function(itemCon, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.num),
        expression: "index == num"
      }],
      key: index,
      staticClass: "iapp_tab_creen_content"
    }, [_c('div', {
      staticClass: "part1"
    }, [_c('p', {
      staticClass: "part_title"
    }, [_vm._v(_vm._s(itemCon.title1))]), _vm._v(" "), _c('p', {
      staticClass: "part_content"
    }, [_vm._v(_vm._s(itemCon.content1))])]), _vm._v(" "), _c('div', {
      staticClass: "part2"
    }, [_c('p', {
      staticClass: "part_title"
    }, [_vm._v(_vm._s(itemCon.title2))]), _vm._v(" "), _c('p', {
      staticClass: "part_content"
    }, [_vm._v(_vm._s(itemCon.content2))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 1),
        expression: "index == 1"
      }],
      staticClass: "part2",
      staticStyle: {
        "z-index": "111",
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "part_title",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('router-link', {
      staticClass: "text-primary",
      attrs: {
        "to": {
          name: 'iVoice'
        }
      }
    }, [_c('a', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "500",
        "color": "#0084ff"
      }
    }, [_vm._v(_vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + " "), _c('Icon', {
      attrs: {
        "type": "arrow-right-c"
      }
    })], 1)])], 1)])])
  }))]), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "iapp_img"
  }, [(_vm.show === 'a') ? _c('div', [(_vm.type1 === 'a') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_store.png"),
      "width": "100%"
    }
  }) : (_vm.type1 === 'b') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_store_fancn.png"),
      "width": "100%"
    }
  }) : (_vm.type1 === 'c') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_store_cn.png"),
      "width": "100%"
    }
  }) : _vm._e()]) : (_vm.show === 'b') ? _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_iVoice.png"),
      "width": "100%"
    }
  })]) : (_vm.show === 'c') ? _c('div', [(_vm.type2 === 'a') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_im.png"),
      "width": "100%"
    }
  }) : (_vm.type2 === 'b') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_im_fancn.png"),
      "width": "100%"
    }
  }) : (_vm.type2 === 'c') ? _c('img', {
    attrs: {
      "src": require("../../assets/iapp/app_im_cn.png"),
      "width": "100%"
    }
  }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.show === 'a') ? _c('div', {
    staticClass: "footer_img"
  }, [_c('p', {
    staticClass: "footer_p"
  }, [_vm._v("STORE")])]) : (_vm.show === 'b') ? _c('div', {
    staticClass: "footer_img"
  }, [_c('p', {
    staticClass: "footer_p"
  }, [_vm._v("IVOICE")])]) : (_vm.show === 'c') ? _c('div', {
    staticClass: "footer_img"
  }, [_c('p', {
    staticClass: "footer_p"
  }, [_vm._v("MESSAGE")])]) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30770294","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/iApp/iapp.vue
// module id = 798
// module chunks = 0